import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";
import React from "react";
import WarningIcon from "../../../../atoms/CustomIcons/WarningIcon";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  apiSubmit: () => void;
  loading: boolean;
  title: string;
  description: React.ReactNode;
  btnText: string;
  btnClass: string;
}

export default function ConfirmStatus(props: PropsType) {
  const { onClose, apiSubmit, loading, title, description, btnText, btnClass } =
    props;

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper deleteModal warningModal">
        <div className="modal_header">
          <div className="title">
            <h3>
              <span>
                <WarningIcon />
              </span>
              {title}
            </h3>
            <p>{description}</p>
          </div>
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            type="default"
            size="large"
            className="outlined-btn"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            type="primary"
            size="large"
            className={btnClass}
            onClick={apiSubmit}
          >
            {btnText}
          </Button>
        </div>
      </div>
    </Spin>
  );
}
